import { render, staticRenderFns } from "./TagBadge.vue?vue&type=template&id=4824b0ec&scoped=true"
import script from "./TagBadge.vue?vue&type=script&lang=js"
export * from "./TagBadge.vue?vue&type=script&lang=js"
import style0 from "./TagBadge.vue?vue&type=style&index=0&id=4824b0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4824b0ec",
  null
  
)

export default component.exports